<div class="admin-content">
  <cei-admin-page-cabecalho
    titulo="Editar Grupo"
    rotaLista="/admin/grupos"
    [rotaVoltar]="['/admin/grupos/detalhe', registroId]"
  />
  <form #adminForm="ngForm" class="admin-form" (ngSubmit)="onSubmit(adminForm)">
    <cei-panel class="admin-form-panel" [height]="'auto'">
      <cei-input-text
        label="Nome:"
        inputId="nome"
        name="nome"
        required
        [(ngModel)]="form.name"
      />

      <section class="admin-form-section">
        <h3 class="admin-form-section__title">Permissões</h3>
        @if (permissoesCatalogoCarregado && formVersao > 0) {
          @if (availablePermissions.length) {
            @for (chave of [chaveAutocompletePermissoes()]; track chave) {
              <cei-autocomplete-chips
                class="admin-autocomplete-chips"
                inputId="grupo-permissoes"
                name="grupo-permissoes"
                placeholder="Buscar permissão..."
                [minSearchLength]="0"
                [(ngModel)]="permissoesSelecionadas"
                [displayWith]="formatarPermissao"
                [displayChipWith]="formatarPermissaoChip"
                [extrairChave]="extrairChavePermissao"
                rotuloChipsAcessibilidade="Permissões selecionadas"
              >
                @for (permissao of availablePermissions; track permissao.id) {
                  <cei-autocomplete-option [value]="permissao">
                    {{ formatarPermissao(permissao) }}
                  </cei-autocomplete-option>
                }
              </cei-autocomplete-chips>
            }
          } @else {
            <p class="admin-form-section__vazio">Nenhuma permissão cadastrada.</p>
          }
        }
      </section>
    </cei-panel>
    <div class="admin-content__actions">
      <cei-button type="submit">Salvar</cei-button>
    </div>
  </form>
</div>
